import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ModalHeaderExtended from '../bootstrap/ModalHeader.js';
import { ModalContext } from '../Modal/Modal';
import CloseButton from '../CloseButton/index.js';
function ModalHeader(_ref) {
  let {
    closeButton = false,
    children
  } = _ref;
  const {
    onHide
  } = useContext(ModalContext) || {};
  return /*#__PURE__*/_jsx(ModalHeaderExtended, {}, void 0, children, closeButton && /*#__PURE__*/_jsx(CloseButton, {
    onClick: onHide
  }));
}
export default ModalHeader;